import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import UsersList from "../../Modals/usersList";
import { useGetNotificationByIdQuery } from "../../services/notification";
import {
  NOTIFICATION_SCHEDULE_TYPE,
  NOTIFICATION_TYPE,
} from "../../constants/enums";
import dayjs from "dayjs";

const NotificationDetail = () => {
  const navigate = useNavigate();
  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);
  const { id } = useParams();

  const handleOpenAudience = (audienceIds: string[]) => {
    setSelectedUserIds(audienceIds);
    setOpenUserModal(true);
  };
  const { data: notificationResponse } = useGetNotificationByIdQuery(
    { id: id || "" },
    { skip: !id }
  );
  const notification = notificationResponse?.data;

  const notificationTypeLabel = React.useMemo(() => {
    const raw = (notification as any)?.type ?? notification?.notificationType;
    const value = typeof raw === "string" ? parseInt(raw, 10) : raw;
    if (!value && value !== 0) return "-";
    switch (value) {
      case NOTIFICATION_TYPE.EMAIL:
        return "Email";
      case NOTIFICATION_TYPE.PUSH:
        return "Push";
      case NOTIFICATION_TYPE.SMS:
        return "SMS";
      default:
        return "-";
    }
  }, [notification]);

  const scheduleLabel = React.useMemo(() => {
    if (!notification) return "-";
    if (notification.scheduleType === NOTIFICATION_SCHEDULE_TYPE.NOW)
      return "Now";
    if (notification.scheduleType === NOTIFICATION_SCHEDULE_TYPE.LATER) {
      return notification.scheduleAt
        ? dayjs(notification.scheduleAt).format("DD MMM YYYY, hh:mm A")
        : "-";
    }
    return notification.scheduleAt
      ? dayjs(notification.scheduleAt).format("DD MMM YYYY, hh:mm A")
      : "Now";
  }, [notification]);

  const usersList = React.useMemo(() => {
    const placeholder = "/static/images/user_placeholder.png";
    const list = (notification?.broadcastReciever || []).map(
      (u: any, idx: number) => ({
        id: u?._id || u?.id || u?.userId || u?.username || String(idx),
        label: u?.username || u?.name || u?.email || `User ${idx + 1}`,
        avatar: u?.avatar || placeholder,
      })
    );
    return list;
  }, [notification]);

  const audienceText = React.useMemo(() => {
    if (notification?.isBroadcast) return "All Users";
    const count = notification?.receiversCount ?? usersList.length;
    return `${count} Users`;
  }, [notification, usersList]);

  // Function to strip HTML tags from text
  const stripHtmlTags = (html: string) => {
    if (!html) return "";
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };
  return (
    <>
      <div className="main_title">
        <h1>Notification Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/manage-notifications")}>
            Notification & Communication Center
          </button>{" "}
          - Notification Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          {/* <div className="vew_img no_radius w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src="/static/images/placeholder.png" />
            </figure>
          </div> */}
          <div className="w_33">
            <h6>Notification Title</h6>
            <p>{notification?.title || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Preview Text</h6>
            <p>{notification?.previewText || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Type</h6>
            <p>{notificationTypeLabel}</p>
          </div>
          {/* <div className="w_33">
            <h6>Audience</h6>
            <p>
              {notification?.isBroadcast ? (
                <>{audienceText}</>
              ) : (
                <button
                  className="anchor_link"
                  onClick={() => handleOpenAudience(usersList.map((u) => u.id))}
                >
                  {audienceText}
                </button>
              )}
            </p>
          </div> */}
          <div className="w_33">
            <h6>Schedule</h6>
            <p>{scheduleLabel}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>
              {notification?.createdAt
                ? new Date(notification?.createdAt).toLocaleDateString()
                : "-"}
            </p>
          </div>
          <div className="w_100">
            <h6>Notification Message</h6>
            <div
              dangerouslySetInnerHTML={{
                __html: notification?.content || notification?.message || "-",
              }}
              style={{ maxWidth: "100%", overflow: "auto" }}
            />
          </div>
        </div>
      </div>

      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />
    </>
  );
};

export default NotificationDetail;
